import { useState, useEffect } from 'preact/hooks';
import Router, { route } from 'preact-router';
import { authenticate, getStoredToken } from './lib/auth';
import { setAuthToken } from './lib/api';
import { getTelegramWebApp } from './lib/telegram';
import { Dashboard } from './pages/Dashboard';
import { Config } from './pages/Config';
import { Restart } from './pages/Restart';
import { Workflows } from './pages/Workflows';
import { Commands } from './pages/Commands';
import { NavBar } from './components/NavBar';
import { VersionFooter } from './components/VersionFooter';

export function App() {
  const [authed, setAuthed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState('/');

  useEffect(() => {
    const init = async () => {
      const tg = getTelegramWebApp();
      tg?.ready();
      tg?.expand();

      // Try stored token first
      const stored = getStoredToken();
      if (stored) {
        setAuthToken(stored);
        setAuthed(true);
        setLoading(false);
        return;
      }

      // Otherwise authenticate via initData
      const user = await authenticate();
      if (user) {
        setAuthed(true);
      } else {
        setError('Zugriff verweigert. Nur autorisierte Nutzer.');
      }
      setLoading(false);
    };
    init();
  }, []);

  // Telegram BackButton integration
  useEffect(() => {
    const tg = getTelegramWebApp();
    if (!tg) return;

    if (currentPath !== '/') {
      tg.BackButton.show();
      const handler = () => {
        route('/');
        tg.HapticFeedback.impactOccurred('light');
      };
      tg.BackButton.onClick(handler);
      return () => {
        tg.BackButton.hide();
      };
    } else {
      tg.BackButton.hide();
    }
  }, [currentPath]);

  function handleRouteChange(e: { url: string }) {
    setCurrentPath(e.url);
    const tg = getTelegramWebApp();
    tg?.HapticFeedback.impactOccurred('light');
  }

  if (loading) return <div class="page"><p>Laden...</p></div>;
  if (error) return <div class="page"><p class="error">{error}</p></div>;
  if (!authed) return <div class="page"><p>Nicht autorisiert.</p></div>;

  return (
    <div class="app-container">
      <div class="app-content">
        <Router onChange={handleRouteChange}>
          <Dashboard path="/" />
          <Config path="/config" />
          <Restart path="/restart" />
          <Workflows path="/workflows" />
          <Commands path="/commands" />
        </Router>
      </div>
      <NavBar currentPath={currentPath} />
    </div>
  );
}
